<!--
 * @Author: Gaho
 * @Date: 2024-05-29 16:43:41
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-19 11:00:39
 * @Description: 
-->
<template>
    <li
        class="text-[#55657e] text-xs ellipsis py-2 px-[6px] rounded-lg items-center font-bold cursor-pointer hover:text-white flex w-full flex-nowrap gap-[4px]"
        :class="[
            currentValue === value && 'bg-[#2A3546FF]',
            currentValue === value && 'text-white',
        ]"
    >
        <slot />
    </li>
</template>

<script setup lang="ts">
const props = defineProps({
    name: {
        type: String,
        default: '',
    },
    value: {
        type: String,
        required: true,
    },
    currentValue: {
        type: String,
        required: true,
    },
});
</script>